import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchUploads, resetStateUploads } from "../../app/slices/uploadSlice";
import { translate } from "../../app/utils";
import EmptyDataContainer from "../emptyDataContainer/emptyDataContainer";
import ErrorContainer from "../errorContainer/errorContainer";
import { Skeleton, Box } from "@mui/material";
import "./bookShowCase.css";

const BookShowCase = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    list: books,
    status,
    error,
  } = useSelector(({ uploads }) => uploads.get);

  const loadResources = useCallback(() => {
    dispatch(resetStateUploads(["get"]));
    dispatch(
      fetchUploads({
        TYPE: "eBook",
        STATUS: "A",
        ignoreLanguage: "Y",
        limit: 5,
        random: "Y",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    loadResources();
  }, [loadResources]);

  const renderBookCards = () => {
    return books.map((book, index) => {
      const bookTitle =
        book[`TITLE_${localStorage.getItem("currentLanguage")?.toUpperCase()}`];
      const bookDescription =
        book[
          `DESCRIPTION_${localStorage
            .getItem("currentLanguage")
            ?.toUpperCase()}`
        ];

      return (
        <div
          className="book-case-card"
          key={`${bookTitle}-${index}`}
          onClick={() => {
            navigate("/books/details", {
              state: {
                book: { ...book },
              },
            });
          }}
        >
          <div className="book-case-image">
            <img 
              src={book.COVER_IMAGE || "/placeholder-book.svg"} 
              onError={(e) => { e.target.onerror = null; e.target.src = "/placeholder-book.svg"; }}
              alt={bookTitle} 
            />
          </div>
          <div className="book-case-details">
            <span id="title">{bookTitle}</span>
            <span id="description">{bookDescription}</span>
            <span id="subtitle">
              {translate("by")}: {book.AUTHOR_NAME}
            </span>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="book-case-wrapper">
      {status === "loading" && (
        <div className="book-case-body">
          {Array.from(new Array(5)).map((_, index) => (
            <Box key={index} className="book-case-card" sx={{ p: 0, overflow: 'hidden' }}>
              <div className="book-case-image" style={{ width: '100%', height: '240px' }}>
                <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
              </div>
              <Box sx={{ p: 2 }}>
                <Skeleton variant="text" width="80%" height={24} animation="wave" />
                <Skeleton variant="text" width="60%" height={20} animation="wave" sx={{ mt: 1 }} />
                <Skeleton variant="text" width="40%" height={16} animation="wave" sx={{ mt: 1 }} />
              </Box>
            </Box>
          ))}
        </div>
      )}

      {books?.length === 0 && status === "idle" && (
        <EmptyDataContainer message="No books found." hasBackground={false} />
      )}

      {error !== null && status !== "loading" && (
        <ErrorContainer
          message={error?.message}
          hasBackground={false}
          onReload={loadResources}
        />
      )}

      <div className="book-case-body">
        {/* <div className="book-case-container"> */}
        {books?.length > 0 && renderBookCards()}
        {/* </div> */}
      </div>
    </div>
  );
};

export default BookShowCase;
